import request from '@/utils/request';


// 获取单位列表
export function GetCompanyList() {
  return request({
    url: '/api/user/subAccount/getList',
    method: 'GET',
  });
}

// 获取列表
export function GetList(params) {
  return request({
    url: '/api/user/subAccount/page',
    method: 'GET',
    params: params
  });
}

// 获取账户类型列表
export function GetAccountTypeList(params) {
  return request({
    url: '/api/custom/register/getCustomTypeList',
    method: 'GET',
    params: params
  });
}

// 保存
export function Save(data) {
  return request({
    url: '/api/user/subAccount/save',
    method: 'POST',
    data
  });
}

// 删除
export function Delete(params) {
  return request({
    url: '/api/user/subAccount/delete',
    method: 'GET',
    params: params
  });
}

// 通过 
export function Pass(data) {
  return request({
    url: '/api/user/subAccount/pass',
    method: 'POST',
    data
  });
}